import { isLoadableImageWirePath } from './assetImageResolve';

export class CreateAssetImageRepickRequiredError extends Error {
  constructor() {
    super('CREATE_IMAGE_REPICK_REQUIRED');
    this.name = 'CreateAssetImageRepickRequiredError';
  }
}

/** Keep only HTTPS/path URLs the server can use without a picked {@link File}. */
export function sanitizeCreateEditorImagePaths(images: unknown): string[] {
  if (!Array.isArray(images)) {
    return [];
  }
  const out: string[] = [];
  for (const item of images) {
    if (typeof item !== 'string') {
      continue;
    }
    const t = item.trim();
    if (t && isLoadableImageWirePath(t)) {
      out.push(t);
    }
  }
  return out;
}

/**
 * Splits create `images[]` into multipart file parts vs JSON URL strings.
 * Bare filenames without a aligned {@link File} throw {@link CreateAssetImageRepickRequiredError}.
 */
export function planCreateAssetImageUpload(
  paths: readonly string[],
  filesAligned: readonly (File | undefined)[],
): { filesToUpload: File[]; imageUrlStrings: string[] } {
  const filesToUpload: File[] = [];
  const imageUrlStrings: string[] = [];
  for (let i = 0; i < paths.length; i++) {
    const f = filesAligned[i];
    const path = paths[i]?.trim() ?? '';
    if (!path) {
      continue;
    }
    if (f) {
      filesToUpload.push(f);
      continue;
    }
    if (isLoadableImageWirePath(path)) {
      imageUrlStrings.push(path);
      continue;
    }
    throw new CreateAssetImageRepickRequiredError();
  }
  return { filesToUpload, imageUrlStrings };
}
